// Import modules...
import { createApp, h } from "vue";
import { App as InertiaApp, plugin as InertiaPlugin } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
// eslint-disable-next-line import/no-webpack-loader-syntax
import languageBundle from "@kirschbaum-development/laravel-translations-loader!@kirschbaum-development/laravel-translations-loader";
import { createI18n } from "vue-i18n";

require("./bootstrap");

const handleLocale = () => {
    switch (window.Locale) {
        case "en-US":
        case "en":
            return "en";

        case "nl-NL":
        case "nl-BE":
            return "nl";

        default:
            return "en";
    }
};

const i18n = createI18n({
    locale: handleLocale(),
    messages: languageBundle,
});

const el = document.getElementById("app");

createApp({
    render: () =>
        h(InertiaApp, {
            initialPage: JSON.parse(el.dataset.page),
            // eslint-disable-next-line global-require,import/no-dynamic-require
            resolveComponent: (name) => require(`./Pages/${name}`).default,
        }),
})
    .mixin({ methods: { route } })
    .use(InertiaPlugin)
    .use(i18n)
    .mount(el);

InertiaProgress.init({ color: "#4B5563" });
